import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PURGE } from "redux-persist";
import apiInstance from '../../../../api';

export const updateAddress = createAsyncThunk(
  'addressesSearch/updateAddress',
  async (data, { rejectWithValue }) => {
    const api = '/address/updateAddress?XDEBUG_SESSION_START=MyVSCode';

    try {
      const response = await apiInstance.post(api, JSON.stringify({ data }));

      if (response.data.result) {
        return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch data');
      }
    } catch (error) {
      console.error('Ошибка при выполнении запроса:', error);
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  }
);

const initialState = {
  addressesSearchRequestStatus: null,
  updateAddressStatus: null,
  addresses: [],
  totalAddresses: 0,
  currentAddressesPage: 1,
};

const addressesSearchSlice = createSlice({
  name: 'addressesSearch',
  initialState,
  extraReducers: (builder) => {
    builder
      // getClientTokens
      .addCase(updateAddress.pending, (state) => { state.updateAddressStatus = 'pending'; })
      .addCase(updateAddress.fulfilled, (state, action) => { state.updateAddressStatus = 'fulfilled'; })
      .addCase(updateAddress.rejected, (state) => { state.updateAddressStatus = 'rejected'; })

      .addCase(PURGE, () => { return initialState; });
  },
  reducers: {
    sendRequestAddressesSearch: (state) => { state.addressesSearchRequestStatus = 'pending'; },
    sendRequestAddressesSearchSuccess: (state) => { state.addressesSearchRequestStatus = 'resolved'; },
    sendRequestAddressesSearchError: (state) => { state.addressesSearchRequestStatus = 'rejected'; },
    clearAddressesSearchStatus: (state) => { state.addressesSearchRequestStatus = null; },
    setAddresses: (state, action) => {
      const data = action.payload;

      state.totalAddresses = data.countAddresses;
      state.addresses = data.addresses;
    },
    setCurrentAddressesPage: (state, action) => {
      state.currentAddressesPage = action.payload;
    },
  },
});

export const {
  sendRequestAddressesSearch,
  sendRequestAddressesSearchSuccess,
  sendRequestAddressesSearchError,
  clearAddressesSearchStatus,
  setAddresses,
  setCurrentAddressesPage,
} = addressesSearchSlice.actions;

export default addressesSearchSlice.reducer;